module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/store_images/4@2x_10442c0e9f174e75c181696d02df22ca.png";